import React, { Component } from 'react'

import PropTypes from 'prop-types'

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components'
import { VFHeaderTabs } from '@vfgroup-oneplatform/foundation/Components/VFHeaderTabs'
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import YourAppointments from '../../Containers/YourAppointments'

class YourAppointmentsScreen extends Component {
  state = {
    activeTab: 0,
    tabs: [
      { index: 0, tab_key: 'your_appointments_current_tab' },
      { index: 1, tab_key: 'your_appointments_past_tab' }
    ]
  }

  onActiveTabChange = ind => {
    this.setState({ activeTab: ind })
  }

  render() {
    const { screenProps, onBookAppointmentsButtonPress, theme, ...rest } = this.props
    return (
      <VFScreen
        title={'your_appointments_screen_title'}
        {...screenProps}
        // withHeaderSpace
      >
        <VFHeaderTabs
          tabs={this.state.tabs}
          activeTab={this.state.activeTab}
          setActiveTab={ind => this.onActiveTabChange(ind)}
          containerStyle={{
            backgroundColor: theme.colors.cardBackgroundColor
          }}
        />
        <YourAppointments
          onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
          currentTab={this.state.activeTab}
          {...rest}
        />
      </VFScreen>
    )
  }
}
YourAppointmentsScreen.propTypes = {
  screenProps: PropTypes.shape(VFScreen.propTypes),
  onBookAppointmentsButtonPress: PropTypes.func,
}
export default withTheme(YourAppointmentsScreen)
